import {BaseContainerModel} from '../base-container.model';
import { app_tenant_deletion_cleanup_history_hdr_RowClass } from '../../dbschema/app_tenant_deletion_cleanup_history_hdr.model';

export class AppTenantDeletionCleanupHistoryHdrContainerModel extends BaseContainerModel {
  app_tenant_deletion_cleanup_history_hdr: app_tenant_deletion_cleanup_history_hdr_RowClass = new app_tenant_deletion_cleanup_history_hdr_RowClass();
}